// routes
import SvgColor from '@Components/svg-color';
// components

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

export const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  transactions: icon('ic_transactions'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  car: icon('ic_car'),
  branch: icon('ic_branch'),
  map: icon('ic_map'),
  rentals: icon('ic_rental'),
  voucher: icon('ic_voucher'),
  pricing: icon('ic_pricing'),
  navTransactions: icon('ic_navTransactions'),
  settings: icon('ic_settings'),
  roles: icon('ic_roles'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'Map', path: '/map', icon: ICONS.map },
      { title: 'Branch', path: '/branches', icon: ICONS.branch },
      { title: 'Vehicles', path: '/vehicles', icon: ICONS.car },
      { title: 'Rentals', path: '/rentals', icon: ICONS.rentals },
      { title: 'Customers', path: '/customers', icon: ICONS.user },
      // { title: 'Voucher', path: '/voucher', icon: ICONS.voucher },
      { title: 'Pricing', path: '/pricing', icon: ICONS.pricing },
      { title: 'Transactions', path: '/Transactions', icon: ICONS.navTransactions },
      // { title: 'Settings', path: '/settings', icon: ICONS.settings },
      { title: 'Roles', path: '/roles', icon: ICONS.roles },
      { title: 'Operator', path: '/operator', icon: ICONS.chat },
    ],
  },
];

export default navConfig;
